import React, { useState, useCallback, useEffect } from 'react';
import ConfiguracionLogic from '../../functions/logic/Configuracion';
import Spiner from '../../components/General/Spiner';
import DynamicCard from '../../components/DataTables/DynamicCard';
import Logs from '../../components/General/LogDetail';
import TableroDetailsAll from './TableroDetailsAll';

const AreaCard = () => {
    const [spiner, setSpiner] = useState(false);
    const [listCardTableros, setListCardTableros] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [selectOption, setSelectOption] = useState('dashboard');

    const handleAccessClick = (idAreaBI) => {
        localStorage.setItem('idAreaBI', idAreaBI);
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click tarjeta area id: " + idAreaBI, 'vizualizar area id: ' + idAreaBI, '/lista-areas', localStorage.getItem('codigoUsuario'));
        window.location.href = global.TABLERO_DETAIL;
    };

    const getAreasTableros = useCallback(async (idArea, page, perPage, seacrh = '') => {
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
        setSpiner(true);
        const respAreas = await ConfiguracionLogic.areasNewLogicBi(idArea, page, perPage, seacrh);
        if (respAreas.success) {
            setListCardTableros(respAreas.data);
            setTotalRows(respAreas.totalRows);
        }
        setSpiner(false);
    }, []);

    useEffect(() => {
        //localStorage.removeItem("returnBiDEtail")
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
        getAreasTableros(0, 1, 9, '');
    }, [getAreasTableros]);

    const handlePageChange = (page, perPage) => {
        getAreasTableros(0, page, 9, '');
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
    };

    const handleSearch = (item) => {
        getAreasTableros(0, 1, 9, item);
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
    };

    const handleSelectChange = (e) => {
        setSelectOption(e.target.value);
        if (e.target.value === "areas") {
            localStorage.setItem('returnBiDEtail', 2)
        }
        else {
            localStorage.setItem('returnBiDEtail', 1)
        }
    };

    return (
        <div className="content-wrapper">
            <Spiner opt={spiner} />
            <div className="d-flex justify-content-start align-items-center mb-3">
                <div className="mr-3">
                    <select
                        onChange={handleSelectChange}
                        value={selectOption}
                        className="form-control"
                    >
                        <option value="dashboard">Dashboard</option>
                        <option value="areas">Áreas</option>
                    </select>
                </div>
            </div>
            {selectOption === 'areas' ? (
                <DynamicCard
                    data={listCardTableros}
                    handleAccessClick={handleAccessClick}
                    headerText="Tableros ingresados"
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                    onSearch={handleSearch}
                />
            ) : <TableroDetailsAll />}
        </div>
    );
};

export default AreaCard;
